import UrlTypes from '@/enums/UrlTypes';
import Provider from '@/enums/Provider';
import { classifyIoSource } from './ioSourceClassifier';
import { classifyErsSource } from './ersSourceClassifier';
import { classifyKbsSource } from './kbsSourceClassifier';

/**
 * Determine URL type from HTML source based on provider.
 */
export function determineUrlTypeFromSource(
    htmlSource: string,
    provider: Provider
): UrlTypes | undefined { // can remove undefined once all providers are implemented
    switch (provider) {
        case Provider.IO:
            return classifyIoSource(htmlSource);
        case Provider.ERS:
            return classifyErsSource(htmlSource);
        case Provider.KBS:
            return classifyKbsSource(htmlSource);
        default:
            return;
    }
}
